import { GOOGLE_DRIVE_CDN, PRODUCT_NO_IMG } from "../../constants";

export const CURRENT_PROMOTION = {
    promo_id: '',
    promo: '',
    pkg_qty: 0,
    info: '',
    end_date: '',
    active: false,
    products: []
};

export const PROMO_INIT = {
    promo: '', //
    price: 0, // precio de promoción
    text: '', // texto de promoción a mostrar en etiqueta de oferta
    fontSize: ''
};

export const OLD_PROMOTION_LIST = [
    {
        name: 'Descuento neto en producto',
        value: 'Descuento$Producto' // directo
    },
    {
        name: 'Descuento en (1) producto',
        value: 'Descuento%Producto' // porcentual
    },
    {
        name: 'En compra de A, descuento de $X en producto B',
        value: 'Compra$Descuento' // directo
    },
    {
        name: 'En compra de producto A, descuento en producto B',
        value: 'Compra%Descuento' // porcentual
    },
    {
        name: 'En compra de producto A y B, descuento en ambos',
        value: 'CompraAB%Descuento'
    },
    {
        name: 'Descuento en compra de "x" productos (Packs)',
        value: 'CompraX%Descuento'
    },
    {
        name: 'Descuento en el segundo producto del mismo tamaño',
        value: 'DescuentoPieza'
    }
];

export const PROMOTION_LIST = [
    {
        name: '2 productos por el precio de 1',
        value: '2x1'
    },
    {
        name: '4 productos por el precio de 3',
        value: '4x3'
    },
    {
        name: 'En compra de producto A y B, producto C gratis',
        value: 'ABC'
    },
    {
        name: 'Descuento en (1) producto',
        value: 'DescuentoProducto'
    },
    {
        name: 'En compra de producto A, descuento en producto B',
        value: 'CompraDescuento'
    },
    {
        name: 'En compra de producto A y B, descuento en ambos',
        value: 'CompraABDescuento'
    },
    {
        name: 'Descuento en compra de "x" productos (Packs)',
        value: 'CompraXDescuento'
    },
    {
        name: 'Descuento en el segundo producto del mismo tamaño',
        value: 'DescuentoPieza'
    },
    {
        name: 'Descuento en línea de productos (NIN, Vitanovo, Zeronovo, etc.)',
        value: 'DescuentoMarca'
    }
];

export const PROMO_PRODUCT = {
    variant_id: '',
    title: '',
    variant_title: '',
    price: 0,
    image_id: `${GOOGLE_DRIVE_CDN}${PRODUCT_NO_IMG}`
};